import React, { useState } from 'react';
import { Database, Terminal, Plus } from 'lucide-react';
import { cn } from '../../../lib/utils';
import DatasetSidebar from './DatasetSidebar';
import FunctionSidebar from './FunctionSidebar';

const DataPanelTabs = ({
  sources,
  udfs,
  previewDataset,
  previewFunction,
  setPreviewDataset,
  setPreviewFunction,
  onConnect,
  onRemoveSource,
  onRebuildSource,
  onManageFunctions,
  onRemoveFunction
}) => {
  const [activeTab, setActiveTab] = useState('datasets');

  return (
    <div className="flex flex-col h-full bg-white dark:bg-gray-950">
      {/* Tab Header */}
      <div className="flex items-center justify-between gap-1 px-3 pt-3 pb-2 shrink-0">
        <div className="flex items-center gap-1">
          <button
            onClick={() => setActiveTab('datasets')}
            className={cn(
              "flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider transition-all rounded-md",
              activeTab === 'datasets'
                ? "text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20"
                : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            )}
          >
            <Database size={12} />
            Datasets
          </button>
          <button
            onClick={() => setActiveTab('functions')}
            className={cn(
              "flex items-center gap-1.5 px-3 py-1.5 text-[10px] font-semibold uppercase tracking-wider transition-all rounded-md",
              activeTab === 'functions'
                ? "text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20"
                : "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
            )}
          >
            <Terminal size={12} />
            Functions
          </button>
        </div>
        <button
          onClick={activeTab === 'datasets' ? onConnect : onManageFunctions}
          className="p-1.5 text-gray-400 hover:text-emerald-600 dark:hover:text-emerald-400 hover:bg-gray-50 dark:hover:bg-gray-900/50 rounded-md transition-all"
          title={activeTab === 'datasets' ? 'Add dataset' : 'Add function'}
        >
          <Plus size={14} />
        </button>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'datasets' && (
          <DatasetSidebar
            sources={sources}
            previewDataset={previewDataset}
            setPreviewDataset={(ds) => {
              setPreviewDataset(ds);
              if (ds) setPreviewFunction(null);
            }}
            onConnect={onConnect}
            onRemoveSource={onRemoveSource}
            onRebuildSource={onRebuildSource}
          />
        )}
        {activeTab === 'functions' && (
          <FunctionSidebar
            udfs={udfs}
            previewFunction={previewFunction}
            setPreviewFunction={(fn) => {
              setPreviewFunction(fn);
              if (fn) setPreviewDataset(null);
            }}
            onManageFunctions={onManageFunctions}
            onRemoveFunction={onRemoveFunction}
          />
        )}
      </div>
    </div>
  );
};

export default DataPanelTabs;
